import { FC, ReactNode } from 'react'

import ExpandLess from '@mui/icons-material/ExpandLess'
import ExpandMore from '@mui/icons-material/ExpandMore'
import { Collapse, List, ListItem, ListItemIcon, ListItemText } from '@mui/material'
import { useToggle } from 'ahooks'

interface MenuCollapseProps {
  icon: ReactNode
  title: string
  children?: ReactNode
}
export const MenuCollapse: FC<MenuCollapseProps> = ({ icon, title, children }) => {
  const [open, { toggle: toggleOpen }] = useToggle(false)

  return (
    <>
      <ListItem onClick={toggleOpen}>
        <ListItemIcon>{icon}</ListItemIcon>
        <ListItemText primary={title} />
        {open ? <ExpandLess /> : <ExpandMore />}
      </ListItem>
      <Collapse in={open} timeout="auto">
        <List component="div">{children}</List>
      </Collapse>
    </>
  )
}
